import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Fade } from 'react-reveal';
import renderHTML from 'react-render-html';
import { Actions } from '../../flux';
import { images, texts, urls } from '../../settings';
import LinhaDoTempoItems from '../../static/json/LinhaDoTempo.json';
import { DelayLink } from '../../components';

import './LinhaDoTempo.scss';

class LinhaDoTempo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      year: '2009',
      textWidthDefault: '49px',
      yearTextWidth: '49px',
      scrollEnabled: true,
      mobile: window.innerWidth <= 768 ? true : false,
      mobileIndex: 0,
      mobileItems: [],
    };

    this.contentText = React.createRef();

    this.years = [
      '2009',
      '2009-1',
      '2010',
      '2010-1',
      '2010-2',
      '2011',
      '2011-1',
      '2011-2',
      '2011-3',
      '2011-4',
      '2011-5',
      '2012',
      '2012-1',
      '2012-2',
      '2012-3',
      '2013',
      '2013-1',
      '2013-2',
      '2014',
      '2014-1',
      '2014-2',
      '2015',
      '2015-1',
      '2015-2',
      '2016',
      '2016-1',
      '2016-2',
      '2017',
      '2017-1',
      '2017-2',
      '2018',
      '2018-1',
      '2018-2',
      '2018-3',
      '2018-4',
      '2019',
      '2019-1',
      '2019-2',
      '2019-3',
      '2019-4',
      '2019-5',
      '2019-6',
    ];
    this.yearsMenu = [
      {
        ano: '2009',
        index: 0,
      },
      {
        ano: '2010',
        index: 2,
      },
      {
        ano: '2011',
        index: 5,
      },
      {
        ano: '2012',
        index: 11,
      },
      {
        ano: '2013',
        index: 15,
      },
      {
        ano: '2014',
        index: 18,
      },
      {
        ano: '2015',
        index: 21,
      },
      {
        ano: '2016',
        index: 24,
      },
      {
        ano: '2017',
        index: 27,
      },
      {
        ano: '2018',
        index: 30,
      },
      {
        ano: '2019',
        index: 35,
      },
    ];
  }

  scrollTop = () => {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  };

  componentDidMount = () => {
    Actions.headerIntern();
    this.scrollTop();

    if (!this.state.mobile) {
      this.getTimeLineScroll();
    } else {
      const items = [];

      LinhaDoTempoItems.map(item => {
        item.items.map(year => {
          let newYear = year;
          year.color = item.color;
          year.year = item.year;
          items.push(newYear);
        });
      });

      this.setState({ mobileItems: items });
    }
  };

  getTimeLineScroll = () => {
    var timeline = document.getElementsByClassName('linha-do-tempo_content__scroll')[0];
    timeline.addEventListener('scroll', e => {
      // Pega o scroll da linha do tempo
      if (e.target.scrollLeft % 10 == 0) {
        // Diminui a quantidade do loop

        let years = document.getElementsByClassName('linha-do-tempo_content__years');
        let finalMargin = e.target.scrollLeft + (window.innerWidth - 1280) / 2;
        if (this.state.scrollEnabled) {
          for (var item of years) {
            // Faz um loop nos anos para ver qual está visível no momento
            let elementBegin = item.offsetLeft;
            // let elementEnd = item.offsetLeft + item.clientWidth;
            let elementEnd = item.offsetLeft + item.scrollWidth;

            if (finalMargin > elementBegin && finalMargin < elementEnd) {
              // Pega o que está ativo, e seta na div
              let year = item.getAttribute('data-ano');
              let index = this.years.map(y => y).indexOf(year);
              if (index < this.years.length) {
                this.changeYear(index);
              }
            }
          }
        }
      }
    });
  };

  disableScrollEvent = (time = 2500) => {
    this.setState({ scrollEnabled: false });
    clearTimeout();

    setTimeout(() => {
      this.setState({ scrollEnabled: true });
    }, time);
  };

  clickYear = index => {
    if (this.state.scrollEnabled == false) return;
    this.disableScrollEvent();
    this.changeYear(index);
  };

  nextYear = () => {
    const { mobileIndex, mobileItems, mobile } = this.state;
    if (mobile) {
      let i = mobileIndex < mobileItems.length - 1 ? mobileIndex + 1 : mobileIndex;
      this.setState({ mobileIndex: i });
    } else {
      if (this.state.scrollEnabled == false) return;
      this.disableScrollEvent(500);
      const { year } = this.state;
      let index = this.years.map(item => item).indexOf(year);
      if (index < this.years.length - 1) {
        this.changeYear(index + 1);
      }
    }
  };

  prevYear = () => {
    const { mobileIndex, mobileItems, mobile } = this.state;
    if (mobile) {
      let i = mobileIndex > 0 ? mobileIndex - 1 : 0;
      this.setState({ mobileIndex: i });
    } else {
      if (this.state.scrollEnabled == false) return;
      this.disableScrollEvent(500);
      const { year } = this.state;
      let index = this.years.map(item => item).indexOf(year);
      if (index > 0) {
        this.changeYear(index - 1);
      }
    }
  };

  changeYear = index => {
    const { textWidthDefault } = this.state;
    let year = this.years[index];
    let divisor = 100 / this.years.length;
    let newWidth = `calc(calc(${divisor}% * ${index}) + ${textWidthDefault})`;
    this.setState({
      year: year,
      yearTextWidth: newWidth,
    });

    this.moveTimeline(year);
  };

  moveTimeline = year => {
    const divClass = `[data-ano="${year}"]`;
    let yearElement = document.querySelector(divClass);
    let leftMargin = 0;
    let scrollElement = document.getElementsByClassName('linha-do-tempo_content__scroll');
    scrollElement = scrollElement[0];

    if (yearElement) {
      leftMargin = yearElement.offsetLeft;

      let finalMargin = leftMargin - (window.innerWidth - 1280) / 2;

      if (year == '2009') {
        scrollElement.scrollTo({
          left: 0,
          behavior: 'smooth',
        });
      } else {
        scrollElement.scrollTo({
          left: finalMargin,
          behavior: 'smooth',
        });
      }
    }
  };

  render = () => {
    const { year, yearTextWidth, mobile, mobileIndex, mobileItems } = this.state;

    return (
      <div className="views" ref={this.contentText}>
        <Helmet>
          <title>Linha do tempo - {texts.title}</title>
        </Helmet>

        <div className="linha-do-tempo-home page-gradient page-gradient--green bg-gray" ref="linha-do-tempo-home">
          <section className="linha-do-tempo-home-area page-gradient__header">
            <div className="container">
              <div className="row">
                <div className="col-5 col-text">
                  <Fade bottom>
                    <div className="page-header">
                      <h3 className="page-header__subtitle">No túnel do tempo:</h3>
                      <h1 className="page-header__title">10 anos de história</h1>
                      <p className="page-header__description gri_text gri_text--fixed">
                        Conheça os grandes marcos da nossa jornada{' '}
                        <span className="gri_label">
                          GRI <b>102-15</b>
                        </span>
                      </p>
                    </div>
                  </Fade>
                </div>

                <div className="col-7 col-image">
                  <img src={images.linha_do_tempo.line} className="line" />
                  <img src={images.linha_do_tempo.perna} className="perna" />
                  <img src={images.linha_do_tempo.corpo} className="corpo" />
                  <img src={images.linha_do_tempo.line_mobile} className="line_mobile" />
                </div>
              </div>
            </div>
          </section>

          <section className="linha-do-tempo-body">
            <div className="container container--large">
              <div className="row">
                <div className="col-12">
                  <div className="governanca-body__content">
                    <Fade bottom>
                      <div className="linha-do-tempo_header">
                        <div className="linha-do-tempo_header linha-do-tempo_header__button">
                          <div
                            className={`c__nav__button c__nav__button--prev ${
                              this.state.scrollEnabled == false ? `disabled` : ``
                            }`}
                            onClick={() => this.prevYear()}
                          ></div>
                        </div>
                        <div className="linha-do-tempo_header linha-do-tempo_header__years">
                          {!mobile && (
                            <ul>
                              {this.yearsMenu.map((item, i) => (
                                <li
                                  key={i}
                                  className={year.includes(item.ano) ? `opt-${item.ano} active` : `opt-${item.ano}`}
                                  onClick={() => this.clickYear(item.index)}
                                >
                                  {item.ano}
                                </li>
                              ))}
                            </ul>
                          )}

                          {mobile && mobileItems.length > 0 && (
                            <ul>
                              <li className={`opt-${mobileItems[mobileIndex].year} active`}>
                                {mobileItems[mobileIndex].year}
                              </li>
                            </ul>
                          )}

                          <div className="timeline_item">
                            <div className="timeline_item--scroll" style={{ width: yearTextWidth }}></div>
                          </div>
                        </div>
                        <div className="linha-do-tempo_header linha-do-tempo_header__button">
                          <div
                            className={`c__nav__button c__nav__button--next ${
                              this.state.scrollEnabled == false ? `disabled` : ``
                            }`}
                            onClick={() => this.nextYear()}
                          ></div>
                        </div>
                      </div>
                    </Fade>
                  </div>
                </div>
              </div>
            </div>

            <div className="container container--fluid linha-do-tempo_items">
              <div className="governanca-body__content">
                <Fade bottom>
                  <div className="linha-do-tempo_content">
                    {mobile && (
                      <div className={`linha-do-tempo_content__scroll linha-do-tempo_content__scroll--${year}`}>
                        <div
                          className={`linha-do-tempo_content__year linha-do-tempo_content__year--mobile`}
                          style={{
                            transform: `translateX(calc(-100vw * ${mobileIndex})`,
                            width: `calc(100vw * ${mobileItems.length})`,
                          }}
                        >
                          {mobileItems.map((item, index) => {
                            return (
                              <div
                                className={`card-container`}
                                key={index}
                                style={{
                                  position: index == mobileIndex ? 'relative' : 'absolute',
                                  left: `calc(100vw * ${index})`,
                                  opacity: index == mobileIndex ? 1 : 0,
                                }}
                              >
                                <div className={`card card--${item.color} card--${index}`}>
                                  <div className="card__content">
                                    <div className="card__content__header">
                                      <h2 className="title">{renderHTML(item.title)}</h2>
                                    </div>
                                    <div className="card__content__body">
                                      <p>{renderHTML(item.text)}</p>
                                    </div>
                                  </div>
                                  {item.image && (
                                    <div className="card__image">
                                      <img src={`${urls.assets}${item.image}`} />
                                    </div>
                                  )}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )}

                    {!mobile && (
                      <div className={`linha-do-tempo_content__scroll linha-do-tempo_content__scroll--${year}`}>
                        {/* 2009 */}
                        <div
                          className="linha-do-tempo_content__year linha-do-tempo_content__year--2009"
                          data-year="2009"
                        >
                          <Fade bottom>
                            <div
                              className="card card--2-3 card--938 card--green linha-do-tempo_content__years"
                              data-ano="2009"
                            >
                              <div className="card__content">
                                <div className="card__content__header">
                                  <h2 className="title">Nascemos</h2>
                                </div>
                                <div className="card__content__body">
                                  <p>
                                    Anbid (Associação Nacional dos Bancos de Investimento) e Andima (Associação Nacional
                                    das Instituições do Mercado Financeiro) unem suas atividades para criar a ANBIMA
                                  </p>
                                </div>
                              </div>
                              <div className="card__image">
                                <img src={images.linha_do_tempo.doismil_09.primeira} />
                              </div>
                            </div>
                          </Fade>

                          <Fade bottom>
                            <div className="card card--green linha-do-tempo_content__years" data-ano="2009-1">
                              <div className="card__content card__content--full">
                                <div className="card__content__header">
                                  <h2 className="title">CEA e CGA </h2>
                                </div>
                                <div className="card__content__body">
                                  <p>
                                    Lançamento da CEA (Certificação de Especialista em Investimentos ANBIMA) e da CGA
                                    (Certificação de Gestores ANBIMA), somando quatro certificações com a CPA-10 e a
                                    CPA-20 (Certificações Profissionais ANBIMA – Séries 10 e 20, respectivamente)
                                  </p>
                                </div>
                              </div>
                            </div>
                          </Fade>
                        </div>
                        {/* 2009 */}

                        {/* 2010 */}
                        <div
                          className="linha-do-tempo_content__year linha-do-tempo_content__year--2010"
                          data-year="2010"
                        >
                          <Fade bottom>
                            <div className="card card--light-yellow linha-do-tempo_content__years" data-ano="2010">
                              <div className="card__content card__content--full">
                                <div className="card__content__header">
                                  <h2 className="title">
                                    Presidência <br />
                                    da Fiafin{' '}
                                  </h2>
                                </div>
                                <div className="card__content__body">
                                  <p>
                                    Assumimos a presidência da Fiafin (Federação Ibero-Americana de Fundos de
                                    Investimento) – deixamos a liderança do grupo em 2014
                                  </p>
                                </div>
                              </div>
                            </div>
                          </Fade>

                          <Fade bottom>
                            <div className="card card--light-yellow linha-do-tempo_content__years" data-ano="2010-1">
                              <div className="card__content card__content--full">
                                <div className="card__content__header">
                                  <h2 className="title">IDkA</h2>
                                </div>
                                <div className="card__content__body">
                                  <p>
                                    Criação do IDkA, índice que mostra o comportamento de aplicações com prazos fixos em
                                    títulos públicos. Ele é o terceiro dos nossos indicadores, junto com o do IMA, que
                                    representa títulos públicos, e o IHFA, que reflete os fundos multimercados
                                  </p>
                                </div>
                              </div>
                            </div>
                          </Fade>

                          <Fade bottom>
                            <div
                              className="card card--light-yellow card--704 linha-do-tempo_content__years"
                              data-ano="2010-2"
                            >
                              <div className="card__content card__content--full">
                                <div className="card__content__header">
                                  <h2 className="title">
                                    Códigos de FIP e <br />
                                    de Negociação
                                  </h2>
                                </div>
                                <div className="card__content__body">
                                  <p>
                                    Lançamento do Código de FIP (Fundos de Investimento em Participações) em parceria
                                    com a ABVCAP e do Código de Negociação (antigo Código Operacional da Andima)
                                  </p>
                                </div>
                              </div>
                            </div>
                          </Fade>
                        </div>
                        {/* 2010 */}

                        {/* 2011 */}
                        <div
                          className="linha-do-tempo_content__year linha-do-tempo_content__year--2011"
                          data-year="2011"
                        >
                          <Fade bottom>
                            <div className="card card--blue linha-do-tempo_content__years" data-ano="2011">
                              <div className="card__content card__content--full">
                                <div className="card__content__header">
                                  <h2 className="title">Presidência da IIFA</h2>
                                </div>
                                <div className="card__content__body">
                                  <p>
                                    Assumimos a presidência da IIFA (Associação Internacional de Fundos de Investimento)
                                    e estivemos no cargo até 2013
                                  </p>
                                </div>
                              </div>
                            </div>
                          </Fade>

                          <Fade bottom>
                            <div className="card card--blue linha-do-tempo_content__years" data-ano="2011-1">
                              <div className="card__content card__content--full">
                                <div className="card__content__header">
                                  <h2 className="title">Sistema Galgo</h2>
                                </div>
                                <div className="card__content__body">
                                  <p>
                                    Disponibilização do Sistema Galgo, pelo qual as instituições enviam informações de
                                    fundos para a Associação e para a B3
                                  </p>
                                </div>
                              </div>
                            </div>
                          </Fade>

                          <Fade bottom>
                            <div
                              className="card card--blue card--340 linha-do-tempo_content__years"
                              data-ano="2011-2"
                            >
                              <div className="card__content card__content--full">
                                <div className="card__content__header">
                                  <h2 className="title">IDA</h2>
                                </div>
                                <div className="card__content__body">
                                  <p>Criação do IDA, nosso índice que mede o desempenho de debêntures</p>
                                </div>
                              </div>
                            </div>
                          </Fade>

                          <Fade bottom>
                            <div
                              className="card card--blue card--799 linha-do-tempo_content__years"
                              data-ano="2011-3"
                            >
                              <div className="card__content card__content--full">
                                <div className="card__content__header">
                                  <h2 className="title">
                                    Códigos de Gestão de Patrimônio e de Novo Mercado de Renda Fixa
                                  </h2>
                                </div>
                                <div className="card__content__body">
                                  <p>Lançamento dos códigos de Gestão de Patrimônio e de Novo Mercado de Renda Fixa</p>
                                </div>
                              </div>
                            </div>
                          </Fade>

                          <Fade bottom>
                            <div className="card card--blue linha-do-tempo_content__years" data-ano="2011-4">
                              <div className="card__content card__content--full">
                                <div className="card__content__header">
                                  <h2 className="title">AEF </h2>
                                </div>
                                <div className="card__content__body">
                                  <p>
                                    Criação da AEF (Associação de Educação Financeira do Brasil) para pôr em prática a
                                    Enef (Estratégia Nacional de Educação Financeira). <br />A entidade desenvolve ações
                                    para estimular a educação financeira na população. <br />
                                    Mantemos a associação em conjunto com a B3, a CNseg e a Febraban
                                  </p>
                                </div>
                              </div>
                            </div>
                          </Fade>

                          <Fade bottom>
                            <div className="card card--blue linha-do-tempo_content__years" data-ano="2011-5">
                              <div className="card__content card__content--full">
                                <div className="card__content__header">
                                  <h2 className="title">Convênio com a Previc</h2>
                                </div>
                                <div className="card__content__body">
                                  <p>
                                    Assinatura de um convênio de cooperação com a Previc para discussão de uma agenda
                                    comum e realização de eventos educacionais
                                  </p>
                                </div>
                              </div>
                            </div>
                          </Fade>
                        </div>
                        {/* 2011 */}

                        {/* 2012 */}
                        <div
                          className="linha-do-tempo_content__year linha-do-tempo_content__year--2012"
                          data-year="2012"
                        >
                          <Fade bottom>
                            <div
                              className="card card--2-3 card--light-green card--1198 card--presidencia-amcc linha-do-tempo_content__years"
                              data-ano="2012"
                            >
                              <div className="card__content">
                                <div className="card__content__header">
                                  <h2 className="title">Presidência do AMCC </h2>
                                </div>
                                <div className="card__content__body">
                                  <p>
                                    Assumimos a presidência do AMCC (Comitê Consultivo de Membros Afiliados) da Iosco
                                    (Organização Internacional das Comissões de Valores Mobiliários). Ficamos na
                                    liderança do grupo até 2018
                                  </p>
                                </div>
                              </div>
                              <div className="card__image">
                                <img src={images.linha_do_tempo.doismil_12.primeira} />
                              </div>
                            </div>
                          </Fade>

                          <Fade bottom>
                            <div className="card card--light-green linha-do-tempo_content__years" data-ano="2012-1">
                              <div className="card__content card__content--full">
                                <div className="card__content__header">
                                  <h2 className="title">Conselho do Ifie</h2>
                                </div>
                                <div className="card__content__body">
                                  <p>
                                    Entramos para o Conselho do Ifie (Fórum Internacional de Educação do Investidor)
                                  </p>
                                </div>
                              </div>
                            </div>
                          </Fade>

                          <Fade bottom>
                            <div className="card card--light-green linha-do-tempo_content__years" data-ano="2012-2">
                              <div className="card__content card__content--full">
                                <div className="card__content__header">
                                  <h2 className="title">Sistema REUNE</h2>
                                </div>
                                <div className="card__content__body">
                                  <p>
                                    Lançamento do Sistema REUNE, plataforma com dados de negociações de debêntures no
                                    mercado secundário – hoje, o sistema conta com dados de CRIs, CRAs e cotas de fundos
                                    fechados
                                  </p>
                                </div>
                              </div>
                            </div>
                          </Fade>

                          <Fade bottom>
                            <div
                              className="card card--light-green card--741 linha-do-tempo_content__years"
                              data-ano="2012-3"
                            >
                              <div className="card__content card__content--full">
                                <div className="card__content__header">
                                  <h2 className="title">
                                    Convênio com <br /> a Susep
                                  </h2>
                                </div>
                                <div className="card__content__body">
                                  <p>
                                    Celebramos um convênio de cooperação com a Susep (Superintendência de Seguros
                                    Privados) para troca de informações visando estimular o desenvolvimento dos mercados
                                    capitais, de seguros e de previdência
                                  </p>
                                </div>
                              </div>
                            </div>
                          </Fade>
                        </div>
                        {/* 2012 */}

                        {/* 2013 */}
                        <div
                          className="linha-do-tempo_content__year linha-do-tempo_content__year--2013"
                          data-year="2013"
                        >
                          <Fade bottom>
                            <div
                              className="card card--2-3 card--yellow card--938 card--convenio-bndes linha-do-tempo_content__years"
                              data-ano="2013"
                            >
                              <div className="card__content">
                                <div className="card__content__header">
                                  <h2 className="title">Convênio com o BNDES</h2>
                                </div>
                                <div className="card__content__body">
                                  <p>Assinatura de convênio com o BNDES para incentivo ao mercado de renda fixa</p>
                                </div>
                              </div>
                              <div className="card__image">
                                <img src={images.linha_do_tempo.doismil_13.primeira} />
                              </div>
                            </div>
                          </Fade>

                          <Fade bottom>
                            <div
                              className="card card--yellow card--378 linha-do-tempo_content__years"
                              data-ano="2013-1"
                            >
                              <div className="card__content card__content--full">
                                <div className="card__content__header">
                                  <h2 className="title">Código de Varejo</h2>
                                </div>
                                <div className="card__content__body">
                                  <p>Lançamento do Código de Varejo</p>
                                </div>
                              </div>
                            </div>
                          </Fade>

                          <Fade bottom>
                            <div
                              className="card card--yellow card--513 linha-do-tempo_content__years"
                              data-ano="2013-2"
                            >
                              <div className="card__content card__content--full">
                                <div className="card__content__header">
                                  <h2 className="title">Ferramenta de precificação </h2>
                                </div>
                                <div className="card__content__body">
                                  <p>Nova ferramenta de precificação permite a consulta diária a curvas de crédito</p>
                                </div>
                              </div>
                            </div>
                          </Fade>
                        </div>
                        {/* 2013 */}

                        {/* 2014 */}
                        <div
                          className="linha-do-tempo_content__year linha-do-tempo_content__year--2014"
                          data-year="2014"
                        >
                          <Fade bottom>
                            <div className="card card--light-blue linha-do-tempo_content__years" data-ano="2014">
                              <div className="card__content card__content--full">
                                <div className="card__content__header">
                                  <h2 className="title">Como Investir em Você</h2>
                                </div>
                                <div className="card__content__body">
                                  <p>
                                    Lançamos o curso online Como Investir em Você, que leva educação financeira para
                                    universitários – atualmente, mais de 35 mil alunos concluíram as aulas
                                  </p>
                                </div>
                              </div>
                            </div>
                          </Fade>

                          <Fade bottom>
                            <div
                              className="card card--2-3 card--light-blue card--938 card--conferencia-iosco linha-do-tempo_content__years"
                              data-ano="2014-1"
                            >
                              <div className="card__content">
                                <div className="card__content__header">
                                  <h2 className="title">39ª Conferência Anual da Iosco</h2>
                                </div>
                                <div className="card__content__body">
                                  <p>
                                    Organização da 39ª Conferência Anual da Iosco (Organização Internacional das
                                    Comissões de Valores Mobiliários) no Rio de Janeiro junto com a B3 (na época, antes
                                    da fusão, como BM&FBovespa e Cetip)
                                  </p>
                                </div>
                              </div>
                              <div className="card__image">
                                <img src={images.linha_do_tempo.doismil_14.primeira} />
                              </div>
                            </div>
                          </Fade>

                          <Fade bottom>
                            <div
                              className="card card--2-3 card--light-blue card--938 linha-do-tempo_content__years"
                              data-ano="2014-2"
                            >
                              <div className="card__content card__content--full">
                                <div className="card__content__header">
                                  <h2 className="title">
                                    Guia de Prevenção à Lavagem de Dinheiro e ao Financiamento do Terrorismo
                                  </h2>
                                </div>
                                <div className="card__content__body">
                                  <p>
                                    Publicação do nosso Guia de Prevenção à Lavagem de Dinheiro e ao Financiamento do
                                    Terrorismo, que contribuiu para o aprimoramento das melhores práticas de prevenção a
                                    esses crimes em fundos de investimento e carteiras administradas
                                  </p>
                                </div>
                              </div>
                            </div>
                          </Fade>
                        </div>
                        {/* 2014 */}

                        {/* 2015 */}
                        <div
                          className="linha-do-tempo_content__year linha-do-tempo_content__year--2015"
                          data-year="2015"
                        >
                          <Fade bottom>
                            <div className="card card--green linha-do-tempo_content__years" data-ano="2015">
                              <div className="card__content card__content--full">
                                <div className="card__content__header">
                                  <h2 className="title">Nova classificação de fundos</h2>
                                </div>
                                <div className="card__content__body">
                                  <p>Lançamento da nossa nova classificação de fundos de investimento</p>
                                </div>
                              </div>
                            </div>
                          </Fade>

                          <Fade bottom>
                            <div
                              className="card card--green card--352 linha-do-tempo_content__years"
                              data-ano="2015-1"
                            >
                              <div className="card__content card__content--full">
                                <div className="card__content__header">
                                  <h2 className="title">SSM</h2>
                                </div>
                                <div className="card__content__body">
                                  <p>
                                    Criação do SSM, sistema utilizado na troca de informações com as instituições que
                                    seguem os códigos de autorregulação
                                  </p>
                                </div>
                              </div>
                            </div>
                          </Fade>

                          <Fade bottom>
                            <div
                              className="card card--green card--340 linha-do-tempo_content__years"
                              data-ano="2015-2"
                            >
                              <div className="card__content card__content--full">
                                <div className="card__content__header">
                                  <h2 className="title">IMA</h2>
                                </div>
                                <div className="card__content__body">
                                  <p>IMA, índice que acompanha a variação dos títulos públicos, completa dez anos</p>
                                </div>
                              </div>
                            </div>
                          </Fade>
                        </div>
                        {/* 2015 */}

                        {/* 2016 */}
                        <div
                          className="linha-do-tempo_content__year linha-do-tempo_content__year--2016"
                          data-year="2016"
                        >
                          <Fade bottom>
                            <div
                              className="card card--2-3 card--light-yellow card--938 card--pesquisa-sustentabilidade linha-do-tempo_content__years"
                              data-ano="2016"
                            >
                              <div className="card__content">
                                <div className="card__content__header">
                                  <h2 className="title">Pesquisa de Sustentabilidade</h2>
                                </div>
                                <div className="card__content__body">
                                  <p>
                                    Criação da Pesquisa de Sustentabilidade, que avalia anualmente o engajamento de
                                    gestoras em questões ASG (ambientais, sociais e de governança)
                                  </p>
                                </div>
                              </div>
                              <div className="card__image">
                                <img src={images.linha_do_tempo.doismil_16.primeira} />
                              </div>
                            </div>
                          </Fade>

                          <Fade bottom>
                            <div
                              className="card card--2-3 card--light-yellow card--938 card--guia-ciberpesquisa linha-do-tempo_content__years"
                              data-ano="2016-1"
                            >
                              <div className="card__content">
                                <div className="card__content__header">
                                  <h2 className="title">Guia de Cibersegurança</h2>
                                </div>
                                <div className="card__content__body">
                                  <p>
                                    Publicação é lançada com práticas para auxiliar o mercado a colocar ações de
                                    segurança cibernética em prática
                                  </p>
                                </div>
                              </div>
                              <div className="card__image">
                                <img src={images.linha_do_tempo.doismil_16.segunda} />
                              </div>
                            </div>
                          </Fade>

                          <Fade bottom>
                            <div className="card card--light-yellow linha-do-tempo_content__years" data-ano="2016-2">
                              <div className="card__content card__content--full">
                                <div className="card__content__header">
                                  <h2 className="title">Atualização das certificações</h2>
                                </div>
                                <div className="card__content__body">
                                  <p>
                                    Renovação da CPA-10 e da CPA-20 passa a ser feita por curso online. Hoje, não há
                                    mais prova de atualização das certificações: todas as renovações são feitas por
                                    cursos, incluindo a CEA e a CGA
                                  </p>
                                </div>
                              </div>
                            </div>
                          </Fade>
                        </div>
                        {/* 2016 */}

                        {/* 2017 */}
                        <div
                          className="linha-do-tempo_content__year linha-do-tempo_content__year--2017"
                          data-year="2017"
                        >
                          <Fade bottom>
                            <div
                              className="card card--2-3 card--blue card--787 card--trajetoria-financeira-brasileiro linha-do-tempo_content__years"
                              data-ano="2017"
                            >
                              <div className="card__content">
                                <div className="card__content__header">
                                  <h2 className="title">A Trajetória Financeira do Brasileiro </h2>
                                </div>
                                <div className="card__content__body">
                                  <p>
                                    Pesquisa A Trajetória Financeira do Brasileiro é feita para entender o comportamento
                                    financeiro das pessoas e como elas se relacionam com dinheiro
                                  </p>
                                </div>
                              </div>
                              <div className="card__image">
                                <img src={images.linha_do_tempo.doismil_17.primeira} />
                              </div>
                            </div>
                          </Fade>

                          <Fade bottom>
                            <div
                              className="card card--blue card--513 linha-do-tempo_content__years"
                              data-ano="2017-1"
                            >
                              <div className="card__content card__content--full">
                                <div className="card__content__header">
                                  <h2 className="title">Foco da autorregulação</h2>
                                </div>
                                <div className="card__content__body">
                                  <p>
                                    Mudança no foco da autorregulação: as regras passaram a ser voltadas para as
                                    atividades dos profissionais, e não mais para os produtos
                                  </p>
                                </div>
                              </div>
                            </div>
                          </Fade>

                          <Fade bottom>
                            <div
                              className="card card--2-3 card--blue card--958 card--informacoes-investidor-brasileiro linha-do-tempo_content__years"
                              data-ano="2017-2"
                            >
                              <div className="card__content card__content--full">
                                <div className="card__content__header">
                                  <h2 className="title">
                                    Central de Informações <br />
                                    sobre o Investidor <br />
                                    Brasileiro
                                  </h2>
                                </div>
                                <div className="card__content__body">
                                  <p>
                                    Lançamos a Central de Informações sobre o Investidor Brasileiro, plataforma gratuita
                                    que reúne estudos e pesquisas sobre pessoas que investem, seus hábitos e motivações
                                  </p>
                                  <img src={images.linha_do_tempo.doismil_17.pc} className="fixed_image" />
                                </div>
                              </div>
                            </div>
                          </Fade>
                        </div>
                        {/* 2017 */}

                        {/* 2018 */}
                        <div
                          className="linha-do-tempo_content__year linha-do-tempo_content__year--2018"
                          data-year="2018"
                        >
                          <Fade bottom>
                            <div
                              className="card card--with-image card--light-green card--1173 card--agenda-anbima linha-do-tempo_content__years"
                              data-ano="2018"
                            >
                              <div className="card__content">
                                <div className="card__content__header">
                                  <h2 className="title">Agenda ANBIMA/ B3 para Mercado de Capitais</h2>
                                </div>
                                <div className="card__content__body">
                                  <p>
                                    Lançamento da Agenda ANBIMA/B3 para Mercado de Capitais: caminho para o
                                    desenvolvimento, e realização do primeiro Congresso Brasileiro de Mercado de
                                    Capitais, em parceria com a B3
                                  </p>
                                </div>
                              </div>
                              <div className="card__image">
                                <img src={images.linha_do_tempo.doismil_18.primeira} />
                              </div>
                            </div>
                          </Fade>

                          <Fade bottom>
                            <div
                              className="card card--light-green card--513 linha-do-tempo_content__years"
                              data-ano="2018-1"
                            >
                              <div className="card__content card__content--full">
                                <div className="card__content__header">
                                  <h2 className="title">Convênio com a CVM</h2>
                                </div>
                                <div className="card__content__body">
                                  <p>
                                    Fechamos um convênio com a CVM para a habilitação de novos administradores de
                                    recursos de terceiros e aproveitamento da supervisão de fundos. Também temos
                                    parcerias para análise prévia de ofertas públicas e aproveitamento de termos de
                                    compromisso e penalidades
                                  </p>
                                </div>
                              </div>
                            </div>
                          </Fade>

                          <Fade bottom>
                            <div
                              className="card card--2-3 card--light-green card--787 card--raiox-investidor-brasileiro linha-do-tempo_content__years"
                              data-ano="2018-2"
                            >
                              <div className="card__content">
                                <div className="card__content__header">
                                  <h2 className="title">Raio X do Investidor Brasileiro</h2>
                                </div>
                                <div className="card__content__body">
                                  <p>
                                    Primeira edição da pesquisa anual Raio X do Investidor Brasileiro, que traça os
                                    hábitos de poupança e investimento da população
                                  </p>
                                </div>
                              </div>
                              <div className="card__image">
                                <img src={images.linha_do_tempo.doismil_18.segunda} />
                              </div>
                            </div>
                          </Fade>

                          <Fade bottom>
                            <div
                              className="card card--light-green card--340 linha-do-tempo_content__years"
                              data-ano="2018-3"
                            >
                              <div className="card__content card__content--full">
                                <div className="card__content__header">
                                  <h2 className="title">ANBIMA Data</h2>
                                </div>
                                <div className="card__content__body">
                                  <p>
                                    Criação do ANBIMA Data, plataforma gratuita com dados de ativos do mercado, como
                                    debêntures e fundos
                                  </p>
                                </div>
                              </div>
                            </div>
                          </Fade>

                          <Fade bottom>
                            <div
                              className="card card--2-3 card--light-green card--761 linha-do-tempo_content__years"
                              data-ano="2018-4"
                            >
                              <div className="card__content card__content--full">
                                <div className="card__content__header">
                                  <h2 className="title">
                                    Códigos de Distribuição e de Administração de Recursos de Terceiros
                                  </h2>
                                </div>
                                <div className="card__content__body">
                                  <p>
                                    Lançamento do Código de Distribuição, que consolida as regras de varejo e de
                                    private, e do Código de Administração de Recursos de Terceiros, que concentra as
                                    normas de fundos e de gestão de patrimônio
                                  </p>
                                </div>
                              </div>
                            </div>
                          </Fade>
                        </div>
                        {/* 2018 */}

                        {/* 2019 */}
                        <div
                          className="linha-do-tempo_content__year linha-do-tempo_content__year--2019"
                          data-year="2019"
                        >
                          <Fade bottom>
                            <div
                              className="card card--2-3 card--yellow card--958 card--agenda-anbima-gestao-recursos linha-do-tempo_content__years"
                              data-ano="2019"
                            >
                              <div className="card__content">
                                <div className="card__content__header">
                                  <h2 className="title">Agenda ANBIMA de Gestão de Recursos</h2>
                                </div>
                                <div className="card__content__body">
                                  <p>
                                    Lançamento da Agenda ANBIMA de Gestão de Recursos: uma visão para o desenvolvimento
                                  </p>
                                </div>
                              </div>
                              <div className="card__image">
                                <img src={images.linha_do_tempo.doismil_19.primeira} />
                              </div>
                            </div>
                          </Fade>

                          <Fade bottom>
                            <div
                              className="card card--yellow card--578 linha-do-tempo_content__years"
                              data-ano="2019-1"
                            >
                              <div className="card__content card__content--full">
                                <div className="card__content__header">
                                  <h2 className="title">Governança de representação</h2>
                                </div>
                                <div className="card__content__body">
                                  <p className="gri_text">
                                    Reestruturação da governança de representação: grupos refletem o movimento do
                                    mercado, que está mais focado nas atividades do que nos produtos
                                  </p>
                                </div>
                              </div>
                            </div>
                          </Fade>

                          <Fade bottom>
                            <div className="card card--yellow linha-do-tempo_content__years" data-ano="2019-2">
                              <div className="card__content card__content--full">
                                <div className="card__content__header">
                                  <h2 className="title">WhatsApp e Workplace</h2>
                                </div>
                                <div className="card__content__body">
                                  <p>
                                    Lançamento de WhatsApp e Workplace, canais exclusivos de comunicação com os
                                    associados
                                  </p>
                                </div>
                              </div>
                            </div>
                          </Fade>

                          <Fade bottom>
                            <div
                              className="card card--2-3 card--yellow card--1047 card--hackaton linha-do-tempo_content__years"
                              data-ano="2019-3"
                            >
                              <div className="card__content">
                                <div className="card__content__header">
                                  <h2 className="title">
                                    Hackathon de Fundos e do Pitch Day para Mercado de Capitais{' '}
                                  </h2>
                                </div>
                                <div className="card__content__body">
                                  <p>
                                    Primeiras edições do Hackathon de Fundos e do Pitch Day para Mercado de Capitais
                                    acontecem em São Paulo
                                  </p>
                                </div>
                              </div>
                              <div className="card__image">
                                <img src={images.linha_do_tempo.doismil_19.segunda} />
                              </div>
                            </div>
                          </Fade>

                          <Fade bottom>
                            <div
                              className="card card--2-3 card--yellow card--772 card--selic linha-do-tempo_content__years"
                              data-ano="2019-4"
                            >
                              <div className="card__content">
                                <div className="card__content__header">
                                  <h2 className="title">Selic</h2>
                                </div>
                                <div className="card__content__body">
                                  <p>
                                    Selic completa 40 anos. Apoiamos o Banco Central na operacionalização do sistema por
                                    meio de uma parceria
                                  </p>
                                </div>
                              </div>
                              <div className="card__image">
                                <img src={images.linha_do_tempo.doismil_19.terceira} />
                              </div>
                            </div>
                          </Fade>

                          <Fade bottom>
                            <div
                              className="card card--yellow card--513 linha-do-tempo_content__years"
                              data-ano="2019-5"
                            >
                              <div className="card__content card__content--full">
                                <div className="card__content__header">
                                  <h2 className="title">Precificação de CRIs e CRAs </h2>
                                </div>
                                <div className="card__content__body">
                                  <p>
                                    Início da precificação de CRIs e CRAs (Certificados de Recebíveis Imobiliários e do
                                    Agronegócio, respectivamente). Também divulgamos preços diários de debêntures e
                                    títulos públicos
                                  </p>
                                </div>
                              </div>
                            </div>
                          </Fade>

                          <Fade bottom>
                            <div
                              className="card card--yellow card--430 linha-do-tempo_content__years"
                              data-ano="2019-6"
                            >
                              <div className="card__content card__content--full">
                                <div className="card__content__header">
                                  <h2 className="title">550 mil certificações</h2>
                                </div>
                                <div className="card__content__body">
                                  <p>
                                    Batemos a marca de 550 mil certificações emitidas, somando CPA-10, CPA-20, CEA e CGA
                                  </p>
                                </div>
                              </div>
                            </div>
                          </Fade>
                        </div>
                        {/* 2019 */}
                      </div>
                    )}
                  </div>
                </Fade>
              </div>
            </div>
          </section>

          <section className="linha-do-tempo-footer-area governanca-footer">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <Fade>
                    <div className="box-pill box-pill--blue box-pill--center">
                      <div className="box-pill__content box-pill__content--full">
                        <div className="row">
                          <div className="col col-5 col--image">
                            <img
                              src={images.linha_do_tempo.pessoas_destaque}
                              className="pessoa_destaque pessoa_destaque--1"
                            />
                          </div>
                          <div className="col col-7 col--text">
                            <h4>Entenda o que é a ANBIMA</h4>
                            <DelayLink
                              to="/quem-somos"
                              className="button button--aylen button--white-to-green button--border-medium button--size-m button--round-l button--text-thick"
                            >
                              Explorar
                            </DelayLink>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  };
}

export { LinhaDoTempo };
